import { Help } from '@mui/icons-material'
import {
  Grid,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material'
import React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

import './style.scss'

interface Props extends RouteComponentProps {
  title: any
  children?: any
  helpText?: string | React.ReactNode
}

const PageHeader = (props: Props) => {
  return (
    <>
      <Grid container spacing={1}>
        <Grid container item>
          <Typography variant="h2">
            {props.title}{' '}
            {props.helpText && (
              <Tooltip title={props.helpText} placement="bottom-start" arrow enterDelay={500}>
                <IconButton size="small" aria-label="Help">
                  <Help fontSize="small" color="action" />
                </IconButton>
              </Tooltip>
            )}
          </Typography>
        </Grid>
        {props.children && (
          <Grid container item>
            {props.children}
          </Grid>
        )}
      </Grid>
    </>
  )
}

export default withRouter(PageHeader)
